import DOMPurify, {
  type UponSanitizeAttributeHookEvent,
} from "dompurify";

const ALLOWED_TAGS = [
  "p",
  "span",
  "strong",
  "em",
  "u",
  "ol",
  "ul",
  "li",
  "br",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "blockquote",
];

const ALLOWED_STYLES = ["text-align", "color", "font-size"];

export function sanitizeRichText(html: string): string {
  const hook = (_node: Element, data: UponSanitizeAttributeHookEvent) => {
    if (data.attrName !== "style") return;

    const sanitizedStyle = data.attrValue
      .split(";")
      .map((style: string) => style.trim())
      .filter((style: string) => {
        if (!style) return false;
        const [property] = style
          .split(":")
          .map((part: string) => part.trim());
        return property !== undefined && ALLOWED_STYLES.includes(property);
      })
      .join("; ");

    if (sanitizedStyle) {
      data.attrValue = sanitizedStyle;
    } else {
      data.keepAttr = false;
    }
  };

  DOMPurify.addHook("uponSanitizeAttribute", hook);

  try {
    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS,
      ALLOWED_ATTR: ["style", "class"],
      FORBID_TAGS: ["script", "style"],
      FORBID_ATTR: ["onerror", "onclick"],
      ALLOW_DATA_ATTR: false,
    });
  } finally {
    DOMPurify.removeHook("uponSanitizeAttribute", hook);
  }
}

